import { Trash, Plus } from "@phosphor-icons/react";

export const QuizEditor = ({ quiz, onChange }) => {
  const update = (i, patch) => onChange(quiz.map((q, j) => (j === i ? { ...q, ...patch } : q)));
  const updateOption = (i, oi, val) => update(i, { options: quiz[i].options.map((o, j) => (j === oi ? val : o)) });

  return (
    <div className="space-y-4" data-testid="quiz-editor">
      {quiz.map((q, i) => (
        <div key={q.id || i} className="p-4 rounded-xl border border-slate-200 bg-slate-50 space-y-3">
          <div className="flex items-center gap-2">
            <span className="font-heading font-extrabold text-sm text-slate-400 w-6">Q{i + 1}</span>
            <input data-testid={`quiz-editor-question-${i}`} value={q.question}
              onChange={(e) => update(i, { question: e.target.value })} placeholder="Question text"
              className="flex-1 h-11 px-3 rounded-lg border border-slate-200 text-sm font-semibold bg-white" />
            <button data-testid={`quiz-editor-remove-${i}`} onClick={() => onChange(quiz.filter((_, j) => j !== i))}
              className="p-2 text-slate-300 hover:text-red-500 tap-press"><Trash size={18} /></button>
          </div>
          <div className="grid sm:grid-cols-2 gap-2">
            {q.options.map((o, oi) => (
              <div key={oi} className={`flex items-center gap-2 px-2 py-1 rounded-lg ${q.correct_index === oi ? "bg-emerald-50 border border-emerald-200" : ""}`}>
                <input type="radio" data-testid={`quiz-editor-correct-${i}-${oi}`} checked={q.correct_index === oi}
                  onChange={() => update(i, { correct_index: oi })} className="h-4 w-4 accent-emerald-600 shrink-0" title="Mark as correct" />
                <input data-testid={`quiz-editor-option-${i}-${oi}`} value={o}
                  onChange={(e) => updateOption(i, oi, e.target.value)} placeholder={`Option ${oi + 1}`}
                  className="flex-1 h-10 px-3 rounded-lg border border-slate-200 text-sm bg-white" />
              </div>
            ))}
          </div>
        </div>
      ))}
      <button data-testid="quiz-editor-add" onClick={() => onChange([...quiz, { question: "", options: ["", "", "", ""], correct_index: 0 }])}
        className="h-11 px-5 rounded-full border-2 border-dashed border-slate-300 text-sm font-bold text-slate-500 tap-press hover:border-slate-900 flex items-center gap-2">
        <Plus size={16} /> Add question
      </button>
    </div>
  );
};
